export const assertUnreachable = (value: never): never => {
  throw new Error(`Unreachable code reached with value: ${value}`);
};
